import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { getReview as universalGetReview, getDeletedReview as universalGetDeletedReview, createReviewAndContact as universalCreateReviewAndContact, createReview as universalCreateReview, bulkCreateReview as universalBulkCreateReview, updateReviewContent as universalUpdateReviewContent, updateReview as universalUpdateReview, deleteReview as universalDeleteReview, bulkDeleteReviews as universalBulkDeleteReviews, queryReviews as universalQueryReviews, setReply as universalSetReply, removeReply as universalRemoveReply, updateModerationStatus as universalUpdateModerationStatus, bulkUpdateModerationStatus as universalBulkUpdateModerationStatus, countReviews as universalCountReviews, } from './reviews-v1-review.universal';
import { AuthorType, ModerationModerationStatus, OriginType, WebhookIdentityType, SortOrder, UpdateModerationStatusRequestModerationStatus, ModerationStatus, } from './reviews-v1-review.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.reviews.v1.review', module_name: 'wix-reviews.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        getReview: (reviewId, options) => {
            const methodLogData = {
                method_name: 'getReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.getReview',
            };
            return universalGetReview(reviewId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getDeletedReview: (reviewId) => {
            const methodLogData = {
                method_name: 'getDeletedReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.getDeletedReview',
            };
            return universalGetDeletedReview(reviewId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createReviewAndContact: (namespace, entityId, content, options) => {
            const methodLogData = {
                method_name: 'createReviewAndContact',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.createReviewAndContact',
            };
            return universalCreateReviewAndContact(namespace, entityId, content, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createReview: (review) => {
            const methodLogData = {
                method_name: 'createReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.createReview',
            };
            return universalCreateReview(review, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateReview: (reviews, options) => {
            const methodLogData = {
                method_name: 'bulkCreateReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.bulkCreateReview',
            };
            return universalBulkCreateReview(reviews, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateReviewContent: (reviewId, options) => {
            const methodLogData = {
                method_name: 'updateReviewContent',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.updateReviewContent',
            };
            return universalUpdateReviewContent(reviewId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateReview: (_id, review, options) => {
            const methodLogData = {
                method_name: 'updateReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.updateReview',
            };
            return universalUpdateReview(_id, review, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteReview: (reviewId) => {
            const methodLogData = {
                method_name: 'deleteReview',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.deleteReview',
            };
            return universalDeleteReview(reviewId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteReviews: (options) => {
            const methodLogData = {
                method_name: 'bulkDeleteReviews',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.bulkDeleteReviews',
            };
            return universalBulkDeleteReviews(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryReviews: (options) => {
            const methodLogData = {
                method_name: 'queryReviews',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.queryReviews',
            };
            return universalQueryReviews(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setReply: (reviewId, message) => {
            const methodLogData = {
                method_name: 'setReply',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.setReply',
            };
            return universalSetReply(reviewId, message, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeReply: (reviewId) => {
            const methodLogData = {
                method_name: 'removeReply',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.removeReply',
            };
            return universalRemoveReply(reviewId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateModerationStatus: (reviewId, options) => {
            const methodLogData = {
                method_name: 'updateModerationStatus',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.updateModerationStatus',
            };
            return universalUpdateModerationStatus(reviewId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateModerationStatus: (options) => {
            const methodLogData = {
                method_name: 'bulkUpdateModerationStatus',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.bulkUpdateModerationStatus',
            };
            return universalBulkUpdateModerationStatus(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countReviews: (options) => {
            const methodLogData = {
                method_name: 'countReviews',
                service_name: 'com.wixpress.critique.reviews.Reviews',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-reviews.v2,entity=wix.reviews.v1.review,environment=velo-frontend,method-fqn=com.wixpress.critique.reviews.Reviews.countReviews',
            };
            return universalCountReviews(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        AuthorType,
        ModerationModerationStatus,
        OriginType,
        WebhookIdentityType,
        SortOrder,
        UpdateModerationStatusRequestModerationStatus,
        ModerationStatus,
    };
}
//# sourceMappingURL=reviews-v1-review.frontend.js.map